import DefaultStore from './DefaultStore';

class Stores {
  stores = {};

  load = (entity, sortColumn = 'nome') =>
    this.stores[entity]
      ? this.stores[entity]
      : (this.stores[entity] = new DefaultStore(entity, sortColumn));

  create = (entity, sortColumn = 'nome') =>
    new DefaultStore(entity, sortColumn);
}

export default new Stores();



// WEBPACK FOOTER //
// ./src/stores/Stores.js